import { useEffect } from "react";
import { change } from "redux-form";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import QuotationService from "services/quotation.service";
import { quotationActions } from "redux/slices/quotation/quotationSlice";

// Rebuild the same `details` shape AutoCompleteApi produces when a location is
// picked, so an edited quotation behaves exactly like a fresh one. Anything that
// reads `details.coordinates` or `details.formatted_address` (distance lookup,
// cross-country pricing) breaks if these are missing.
const hydrateLocationDetails = (saved: any) => ({
  address: saved?.address,
  place_id: saved?.place_id,
  airport: saved?.airport,
  name: saved?.address,
  formatted_address: saved?.address,
  coordinates: saved?.coordinates,
  geometry: { location: saved?.coordinates },
});

export default function UpdateQuotationForm({ id }: any) {
  const form = "AddQuotationForm";
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const Quotation = useAppSelector((state) => state.quotation.quotation);

  useEffect(() => {
    QuotationService.getQuotation(id);
    return () => {
      dispatch(quotationActions.setQuotation(null));
    };
  }, [id, dispatch]);

  useEffect(() => {
    if (!Quotation || Quotation?.data === "Not Found") return;
    const { company_name, person_name, company_email, company_address, company_address2, title, message, message2, bookings, discount, language } = Quotation;
    dispatch(change(form, "company_name", company_name));
    dispatch(change(form, "person_name", person_name));

    dispatch(change(form, "company_email", company_email));
    dispatch(change(form, "company_address", company_address));
    dispatch(change(form, "company_address2", company_address2));
    dispatch(change(form, "title", title));
    dispatch(change(form, "message", message));
    dispatch(change(form, "message2", message2));
    dispatch(change(form, "discount", discount));
    dispatch(change(form, "language", language == 'English'));
    let bookingList = bookings?.map((item: any) => {
      let booking = { ...item }
      if (booking.start_date) booking.start_date = { date: booking.start_date, error: false }
      if (booking.end_date) booking.end_date = { date: booking.end_date, error: false }
      if (booking.pickup) {
        booking.pickup = { value: booking.pickup }
        if (booking.pickup_details) {
          booking.pickup.details = hydrateLocationDetails(booking.pickup_details)
        }
      }
      if (booking.destination) {
        booking.destination = booking.hourly ? booking.destination : { value: booking.destination }
        if (booking.destination_details) {
          booking.destination.details = hydrateLocationDetails(booking.destination_details)
        }
      }
      return booking
    })

    dispatch(change(form, "bookings", bookingList));
    setTimeout(() => {
      dispatch(change(form, "bookings", bookingList));
    }, 2000);

  }, [navigate, dispatch, Quotation]);

  return null;
}
